import * as s from "@gromia/components/theme/t.module.css";
import { replicateSeparator } from "@gromia/utils";
import cx from "classnames";
import { flatten, zip } from "fp-ts/lib/Array";
import React from "react";

type StatProps = {
  stat: NonNullable<React.ReactNode>;
  sub: NonNullable<React.ReactNode>;
};

export const Sep = () => (
  <svg
    viewBox="0 0 32 12"
    height={12}
    width={32}
    xmlns="http://www.w3.org/2000/svg"
    className={cx(s.mb3, s.mt3)}
  >
    <g fill="white" opacity={0.2}>
      <circle cx={3} cy={6} r={3} />
      <circle cx={16} cy={6} r={6} />
      <circle cx={29} cy={6} r={3} />
    </g>
  </svg>
);

type Props = {
  children: NonNullable<React.ReactNode>;
};

export const Statistics = (props: Props) => {
  const children = React.Children.toArray(props.children);
  const separators = replicateSeparator(children.length, Sep);

  return (
    <div className={cx(s.textWhite, s.container)}>
      <div
        className={cx(
          s.dFlex,
          s.justifyContentBetween,
          s.alignItemsCenter,
          s.flexColumn,
          s.flexMdRow,
          s.spaceTop2,
          s.spaceBottom2,
          s.offsetLg1,
          s.colLg10,
        )}
      >
        {flatten(zip(children, separators))}
      </div>
    </div>
  );
};

export const Statistic = (props: StatProps) => (
  <div className={s.textCenter}>
    <div className={s.fontSizeHuge3}>{props.stat}</div>
    <div className={s.fontSizeLarge1} style={{ maxWidth: 180 }}>
      {props.sub}
    </div>
  </div>
);
